<template>
  <div class="bg_gray">
    <!-- 广告幻灯片 -->
    <van-swipe :autoplay="3000" lazy-render ref="carousel" class="scroll_banners" v-if="advertList && advertList.length !== 0">
      <van-swipe-item v-for="item in advertList" :key="item.id">
         <img :src="item.image" v-if="item.href === ''">
         <a href="#" @click="updateAdvert(item)" v-else><img :src="item.image"></a>
         <!--<a :href="item.href" v-else-if="item.mode===1" target="_blank" @click="updateAdvert(item.id)"><img :src="item.image"></a>-->
         <!--<a :href="item.href" v-else-if="item.mode===2" target="" @click="updateAdvert(item.id)"><img :src="item.image"></a>-->
      </van-swipe-item>
    </van-swipe>
    <!-- 简介 -->
    <div class="intro">
      <h1>企业内训</h1>
      <p>企业内训是推动企业不断发展的重要手段之一。我们以整合培训产业价值体系为宗旨，以客户需求为导向，期许通过整合学习资源，与各专家及专业机构携手，为企业提供专业、丰富、便捷、高效的全方位培训服务，共同搭建企业的知识管理平台，提升企业核心竞争力与促进学习产业发展。</p>
      <div class="text-center">
        <van-button type="primary" @click="anchorLinkTo('applyFormAll')">立即申请</van-button>
      </div>
    </div>
    <!-- 服务项目 -->
    <div class="area_service">
      <h1 class="title_h1">服务项目<span>多元化教学形式，满足企业差异化培训需求</span></h1>
      <van-row gutter="15">
        <van-col span="12">
          <div class="service_item">
            <div class="icon orange">
              <i class="iconfont icon-icon-102"></i>
            </div>
            <h3>企业定制培训</h3>
            <p>定制企业培训课程，提供讲师、助教、教学资料、实验资源等教学服务，多种教学模式任意组合。</p>
          </div>
        </van-col>
        <van-col span="12">
          <div class="service_item">
            <div class="icon green">
              <i class="iconfont icon-icon-113"></i>
            </div>
            <h3>认证培训</h3>
            <p>提供阿里云、腾讯云等多家知名厂商的认证培训课程及认证考试服务。</p>
          </div>
        </van-col>
        <van-col span="12">
          <div class="service_item">
            <div class="icon red">
              <i class="iconfont icon-icon-122"></i>
            </div>
            <h3>直播培训</h3>
            <p>为企业开通专属直播课堂，既支持上万人同时在线的大型培训，也满足强互动需求的小规模培训。</p>
          </div>
        </van-col>
        <van-col span="12">
          <div class="service_item">
            <div class="icon blue">
              <i class="iconfont icon-icon-131"></i>
            </div>
            <h3>视频培训</h3>
            <p>丰富的在线视频课程库，涵盖前沿热门技术，针对性提供技术提升方案。</p>
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- 知识体系 -->
    <div class="area_system">
      <img :src="require('assets/img/pic/nx_m.png')" />
      <h1>知识体系<span>课程全面覆盖 ICT 技术领域，帮助团队全方位系统化提升技术能力</span></h1>
    </div>
    <!-- 核心优势 -->
    <div class="area_advantage">
      <h1 class="title_h1">核心优势<span>高标准，深技术，严保障，用心服务好每一位培训人员</span></h1>
      <van-row gutter="15">
        <van-col span="12">
          <div class="advantage_item skyblue">
            <div class="card">
              <div class="icon">
                <i class="iconfont icon-icon-141"></i>
              </div>
              <h3>优质的培训课程</h3>
              <p>与众多企业深度合作，实时跟进前沿热门技术。由专业的讲师和课程研发团队共同定制培训方案，严格把控培训课程质量。</p>
            </div>
          </div>
        </van-col>
        <van-col span="12">
          <div class="advantage_item red">
            <div class="card">
              <div class="icon">
                <i class="iconfont icon-icon-15"></i>
              </div>
              <h3>专业的师资团队</h3>
              <p>大厂技术大牛+硬核讲师，为教学质量保驾护航。培训讲师来自国内外知名企业，均有多年企业实战经验和教学经验。</p>
            </div>
          </div>
        </van-col>
        <van-col span="12">
          <div class="advantage_item blue">
            <div class="card">
              <div class="icon">
                <i class="iconfont icon-icon-16"></i>
              </div>
              <h3>高效的学习平台</h3>
              <p>提供免费私有云/公有云学习平台，实操环节学员独享快速、高效、灵活的实验实训环境，还原最真实的企业生产环境。</p>
            </div>
          </div>
        </van-col>
        <van-col span="12">
          <div class="advantage_item purple">
            <div class="card">
              <div class="icon">
                <i class="iconfont icon-icon-17"></i>
              </div>
              <h3>贴心的助学服务</h3>
              <p>由课程的核心讲师带队，助教老师一对一在线批改作业、讲解答疑，保证学习过程中的及时交互。</p>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- 培训流程 -->
    <div class="area_train">
      <h1 class="title_h1">培训流程<span>规范化流程，全面跟踪落实企业培训</span></h1>
      <van-row gutter="15">
        <van-col span="12">
          <div class="train_item">
            <div class="top">STEP 1</div>
            <h3>明确培训需求</h3>
            <p>与客户代表及专家顾问深度沟通，明确培训需求及标准。</p>
          </div>
        </van-col>
        <van-col span="12">
          <div class="train_item">
            <div class="top">STEP 2</div>
            <h3>制定培训方案</h3>
            <p>根据企业的培训需求，量身定制培训方案。</p>
          </div>
        </van-col>
        <van-col span="12">
          <div class="train_item">
            <div class="top">STEP 3</div>
            <h3>签订培训协议</h3>
            <p>确认企业培训实施细节，签署培训协议。</p>
          </div>
        </van-col>
        <van-col span="12">
          <div class="train_item">
            <div class="top">STEP 4</div>
            <h3>实施培训计划</h3>
            <p>按照培训协议约定，实施培训。专属客服全程跟踪培训，保证课程质量。</p>
          </div>
        </van-col>
        <van-col span="24">
          <div class="train_item">
            <div class="top">STEP 5</div>
            <h3>评估培训效果</h3>
            <p>培训结束后提交学员反馈，评估课程培训效果，协助企业对项目复盘。</p>
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- 立即申请 -->
    <div class="area_apply">
      <h1 class="title_h1">立即申请<span>为您定制企业专属培训方案</span></h1>
      <div class="apply_sheet" ref="applyFormAll">
        <van-tabs v-model:active="applyActive" title-active-color="#00ADEF" line-width="0" class="tab_common" @change="changeApplyTab">
          <van-tab title="申请信息">
            <van-form label-width="50" ref="applyForm">
              <van-cell-group inset>
                <van-field
                  v-model="applyModal.form.applyer_name"
                  name="姓名"
                  label="姓名"
                  placeholder="请填写姓名"
                  :formatter="formatter1"
                  :rules="applyModal.rules.applyer_name"
                />
                <van-field
                  v-model="applyModal.form.cellphone"
                  name="电话"
                  label="电话"
                  placeholder="请填写电话"
                  :formatter="formatter1"
                  :rules="applyModal.rules.cellphone"
                />
                <van-field
                  v-model="applyModal.form.company"
                  name="单位"
                  label="单位"
                  placeholder="请填写单位"
                  :formatter="formatter1"
                  :rules="applyModal.rules.company"
                />
                <van-field
                  v-model="applyModal.form.require"
                  type="textarea"
                  name="需求"
                  label="需求"
                  placeholder="请填写需求"
                  :formatter="formatter1"
                  :rules="applyModal.rules.require"
                />
                <van-field :border="false"
                  v-model="applyModal.form.input_code"
                  name="验证码"
                  label="验证码"
                  placeholder="请填写验证码"
                  :rules="applyModal.rules.input_code"
                ></van-field>
                <van-field label=" ">
                  <template #input>
                    <SIdentify @getCode="getCode" ref="s-identify"></SIdentify>
                  </template>
                </van-field>
              </van-cell-group>
              <div style="margin: 15px 30px;">
                <van-button block type="primary" @click="submitForm('applyForm')">立即申请</van-button>
              </div>
            </van-form>
          </van-tab>
          <van-tab title="已申请">
            <div class="apply_list" v-if="showNameList">
              <div class="name_list">
                <ul :class="{'animate': isScroll}" ref="nameList">
                  <li v-for="item in nameList" >
                    <span>{{ (item.applyer_name) }}</span>
                    <span>{{ (item.cellphone) }}</span>
                    <span class="text_ellipsis">{{ (item.company) }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import { checkTrainPhone } from 'utils/mobile/common.js'
  import { createTrain, getTrain } from 'api/training/list'
  import { showMessage } from 'api/base/mobile/message'
  import SIdentify from 'components/common/SIdentify'
  import { getAdvertList, updateHitNum } from 'api/advert/admin'
  export default {
    components: {
      SIdentify
    },
    data() {

      let checkApplyName = (value, rule) => {
        return new Promise(resolve => {
            if (value.length > 15){
                resolve('名称请保持15个字符以内')
            }else {
                resolve(true)
            }
        })
      }
      let checkCompany = (value, rule) => {
        return new Promise(resolve => {
            if (value.length > 20){
                resolve('单位请保持20个字符以内')
            }else {
                resolve(true)
            }
        })
      }
      let checkRequire = (value, rule) => {
        return new Promise(resolve => {
            if (value.length > 100){
                resolve('需求请保持100个字符以内')
            }else {
                resolve(true)
            }
        })
      }

      let checkInputLengthRule = (value, rule) => {
        if(value.length >= 50){
          return '字符长度限制在1到50个字符以内';
        }
        let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
        if(iconRule2.test(value)){
          return "不能包含表情符号"
        }
        return true;

      }

      return {
        applyActive: 0,
        showNameList: true,
        nameListNeedScroll: false,
        isScroll: false,
        scrollHandler:'',
        nameList:[],
        advertList: [],
        code:'',
        applyModal: {
          visible: false,
          form: {
            applyer_name: '',
            cellphone: '',
            company: '',
            require: '',
            input_code:''
          },
          rules: {
            applyer_name: [
              { required: true, message: '请输入姓名', trigger: 'onBlur' },
              { validator: checkApplyName,trigger: 'onBlur'},
              { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
            ],
            cellphone: [
              { required: true, message: '请输入手机号', trigger: 'onBlur' },
              { validator: checkTrainPhone, trigger: 'onBlur' },

            ],
            company: [
              { required: true, message: '请输入单位名称', trigger: 'onBlur' },
              { validator: checkCompany ,trigger: 'onBlur'},
              { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
            ],
            require: [
              { required: true, message: '请输入需求', trigger: 'onBlur' },
              { validator: checkRequire ,trigger: 'onBlur'},
              { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
            ],
            input_code: [
              { required: true, message: '请输入验证码', trigger: 'onBlur' }
            ],
          }
        },
      }
    },
    mounted() {
      this.getAdvertList();
    },
    methods: {
      formatter1(value) {
        // 拒绝直接输入空格
        return value.replace(/^ +| +$/g, '');
      },
      getCode(val) {
        this.code = val
      },
      changeApplyTab() {
        this.stopScroll()
        if(this.applyActive === 1) {
            this.applyModal.form.applyer_name = ''
            this.applyModal.form.cellphone = ''
            this.applyModal.form.company = ''
            this.applyModal.form.require = ''
            this.applyModal.form.input_code = ''
          this.getTrainList()
        }
      },
      submitForm(formName) {
          this.$refs[formName].validate().then(() => {
            var values = this.applyModal.form
            if (values.input_code != this.code) {
              showMessage("验证码有误请重新输入(区分大小写)！")
            }else {
              createTrain(values).then(() => {
                this.$refs.applyForm.resetValidation()
                this.showNameList = false;
                showMessage("申请成功！",'success').then(()=>{
                  this.applyModal.form.applyer_name = ''
                  this.applyModal.form.cellphone = ''
                  this.applyModal.form.company = ''
                  this.applyModal.form.require = ''
                  this.applyModal.form.input_code = ''
                  this.applyActive = 1;
                  this.showNameList = true;
                  this.getTrainList()
                })
              })
            }
            this.$refs['s-identify'].refreshCode();
          }).catch(err=>{
            showMessage("所填内容有误(请按照要求填写)！");
            this.$refs['s-identify'].refreshCode();
            return false;
          });
      },
      getTrainList() {
        let filters = {
          'limit': 20,
          'offset': 0
        }
        getTrain(filters).then((res) =>{
          this.nameList = res.data;
          this.$nextTick(()=>{
              if(this.$refs.nameList.offsetHeight > 282) {
                this.nameListNeedScroll = true;
                this.startScroll();
              }
          });
        })
      },
      getAdvertList() {
        const that = this
        let filters = {
          location: 1,
          state:  1,
          order: true
        }
        getAdvertList(filters).then(res => {
          that.advertList = res.data
        })
      },
      updateAdvert(adv) {
        let data = new FormData();
        data.append('up_hit_num', '1');
        const id = adv.id
        updateHitNum(id, data).then(() => {
        })

        if(adv.mode === 1){
          if(adv.href){
            window.open(adv.href)
          }
        }
        else {
          if(adv.href){
            location.href = adv.href
          }
        }

      },
      nameScroll() {
        this.isScroll = true;
        setTimeout(()=>{
           this.nameList.push(this.nameList[0]);
           this.nameList.shift();
           this.isScroll = false;
        },500)
      },
      startScroll() {
        if(this.nameListNeedScroll) {
          this.scrollHandler = setInterval(this.nameScroll,1000);
        }
      },
      stopScroll() {
        if(this.nameListNeedScroll) {
          clearInterval(this.scrollHandler);
        }
      },
      anchorLinkTo (ref) {
        this.applyActive = 0;
        window.scrollTo({
            top: this.$refs[ref].getBoundingClientRect().top,
            behavior: "smooth"
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .title_h1 {
    font-size:16px;
    text-align:center;
    color:#333;
    margin-top:0;
    margin-bottom:20px;
    span {
      display: block;
      color: #999;
      font-size: 14px;
      margin-top: 10px;
      font-weight: normal;
    }
  }
  .intro {
    background:#fff;
    padding:15px 15px 20px 15px;
    > h1 {
      font-size:18px;
      margin:0 -15px 10px -15px;
      padding:0 15px 10px 15px;
      color: var(--van-primary-color);
      border-bottom:1px solid #f1f5f8;
    }
    > p {
      line-height:1.5;
    }
    button {
      width: 60%;
    }
  }
  .area_service {
    padding:20px 15px;
    .van-col {
      margin-bottom: 15px;
    }
    .service_item {
      background:#fff;
      padding:15px 10px;
      text-align:center;
      border-radius: 5px;
      height:100%;
      margin-bottom:15px;
      .icon {
        width:50px;
        height:50px;
        border-radius:50%;
        text-align: center;
        line-height: 50px;
        margin:0 auto 15px;
        i {
          color:#fff;
          font-size: 32px;
        }
        &.orange {
          background:#fda83b;
        }
        &.green {
          background:#78be78;
        }
        &.red {
          background:#f15a51;
        }
        &.blue {
          background:#4aa8f2;
        }
      }
      h3 {
        font-size: 14px;
        color:#333;
        margin-top:0;
        margin-bottom:10px;
      }
      p {
        font-size:12px;
        line-height:1.5;
        margin:0;
      }
    }
  }
  .area_system {
    position: relative;
    text-align: center;
    > img {
      display:block;
      width:100%;
    }
    h1 {
      font-size:16px;
      color:#fff;
      position:absolute;
      top:10%;
      left:0;
      right:0;
      margin:0;
      padding-left:20px;
      padding-right:20px;
      > span {
        display:block;
        color:#ccc;
        font-size:14px;
        font-weight:normal;
        margin-top:10px;
      }
    }
  }
  .area_advantage {
    padding:20px 15px;
    .advantage_item {
      padding:15px 0;
      position:relative;
      height:100%;
      .card {
        border-radius:8px;
        padding:15px;
        text-align:center;
        position:relative;
        overflow:hidden;
        height:100%;
        .icon {
          width:50px;
          height:50px;
          border-radius:50%;
          text-align:center;
          line-height:50px;
          background:rgba(255,255,255,0.4);
          margin:0 auto 15px;
          > i {
            color:#fff;
            font-size:32px;
          }
        }
        h3 {
          color:#fff;
          margin-top:0;
          margin-bottom:10px;
          font-size:14px;
        }
        p {
          font-size:12px;
          color:#fff;
          line-height:1.5;
        }
        &:before {
          content: '';
          background:url('~@/assets/img/bg/nx_light.png') no-repeat top center;
          background-size:cover;
          position:absolute;
          left:0;
          right:0;
          top:0;
          bottom:0;
        }
      }
      &:before {
        content: '';
        position:absolute;
        left:10px;
        top:0;
        right:10px;
        bottom:0;
        border-radius:8px;
      }
      &.skyblue {
        .card {
          background:#4aa8f2;
        }
        &:before {
          background:#e5f3ff;
        }
      }
      &.red {
        .card {
          background: #f15a51;
        }
        &:before {
          background:#feeeed;
        }
      }
      &.blue {
        .card {
          background: #408cff;
        }
        &:before {
          background:#ebf3ff;
        }
      }
      &.purple {
        .card {
          background: #7453bc;
        }
        &:before {
          background:#f1edf8;
        }
      }
    }
  }
  .area_train {
    padding:20px 15px;
    background:#fff;
    .title_h1 {
      margin-bottom:35px;
    }
    .van-col {
      margin-bottom:30px;
    }
    .train_item {
      border-radius:8px;
      background:#f5f7fb;
      padding:30px 10px 10px 10px;
      position:relative;
      text-align:center;
      height:100%;
      .top {
        color:#fff;
        padding:6px 45px 6px 20px;
        border-radius: 20px 20px 20px 0;
        background:#4aa8f2;
        position:absolute;
        top:-14px;
        left:0;
      }
      h3 {
        color:#333;
        margin-top:0;
        margin-bottom: 10px;
        font-size:14px;
      }
      p {
        line-height:1.5;
        margin:0;
        font-size:12px;
      }
      > img {
        position:absolute;
        bottom:-1px;
        left:0;
        width:100%;
      }
    }
  }
  .area_apply {
    padding:20px 15px;
    .apply_sheet {
      background:#fff;
      border-radius:4px;
      box-shadow: 0 0 0 rgba(0,0,0,0.5);
      padding:0 0 10px 0;
      .van-cell-group {
        margin:0;
      }
    }

    .apply_form {
      border-radius:4px;
      overflow:hidden;
      background:#fff;
      -webkit-box-shadow: 0 0 10px rgba(0,0,0,0.1);
      box-shadow: 0 0 10px rgba(0,0,0,0.1);
      position:relative;
      z-index:1;
      .head {
        padding:22px 40px;
        background:#4aa8f2;
        color:#fff;
      }
      .content {
        padding:30px 30px 30px 0;
        .tip {
          font-size:12px;
          margin-left:15px;
          color:#999;
        }
      }
    }
    .apply_list {
      padding:10px 10px 0 10px;
      .name_list {
        height:282px;
        overflow:hidden;
        position:relative;
        ul {
          position:absolute;
          top:0;
          left:0;
          right:0;
          li {
            padding:15px 10px;
            border-bottom:1px solid #f0f0f0;
            display:flex;
            span {
              width:33.333%;
            }
          }
          &.animate {
            -webkit-transition: all 0.5s;
            transition: all 0.5s;
            top: -47px;
          }
        }
      }
    }
  }
</style>
